// extracted by mini-css-extract-plugin
export default {"socialBtnsContainer":"SocialBtns_socialBtnsContainer__-3Fg-","socialBtn":"SocialBtns_socialBtn__1RQcs"};